import * as React from 'react';
import { colors } from '../../../../../utils/styles/defaultTheme';

function AutomationsRepeat({ color = colors.actionMinor[500], ...props }) {
    return (
        <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
            <path
                fill={color}
                d="M14 10h6l-1.675 2.009a6 6 0 0 0-6.16 7.392L10 22H8l1-7H4l9-13h2l-1 8Z"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M14 18c0 1.105.455 2.1 1.18 2.82L14 22h3v-3l-1.12 1.12A2.995 2.995 0 0 1 17 15.175V14.13A3.997 3.997 0 0 0 14 18Zm8-4h-3v3l1.12-1.12A2.995 2.995 0 0 1 19 20.825v1.045A3.997 3.997 0 0 0 22 18c0-1.105-.455-2.1-1.18-2.82L22 14Z"
                clipRule="evenodd"
            />
        </svg>
    );
}

export default AutomationsRepeat;
